import { type UUID } from '@bizzdesign/bizzdesign-sdk/uuid';
import { type CommentModeLocation } from '@bizzdesign/modeler/models';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

/** Operations of the comment store that can fail against the API. */
export type CommentOperation =
  | 'load'
  | 'createThread'
  | 'reply'
  | 'editComment'
  | 'deleteComment'
  | 'deleteThread'
  | 'moveThread'
  | 'markRead';

export const commentUiEvents = eventGroup({
  source: 'Comments UI',
  events: {
    commentModeToggled: type<{
      isOn: boolean;
      location: CommentModeLocation;
    }>(),
    commentsVisibilityChanged: type<{
      isVisible: boolean;
      location: CommentModeLocation;
    }>(),
  },
});

export const commentApiEvents = eventGroup({
  source: 'Comments API',
  events: {
    threadCreated: type<{ threadId: UUID; isAttachedToGraphic: boolean }>(),
    replyAdded: type<{ threadId: UUID }>(),
    commentOperationFailed: type<{
      operation: CommentOperation;
      message: string;
    }>(),
  },
});
